import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-taxback-offline',
  templateUrl: './taxback-offline.component.html',
  styleUrls: ['./taxback-offline.component.scss']
})
export class TaxbackOfflineComponent {
  @Output() action: EventEmitter<void>;

  constructor() { 
    this.action = new EventEmitter<void>();
  }

  submit(): void {
    this.action.next();
  }
}
